import { useCallback, useEffect, useState } from "react";
import { FormControlChildProps } from "../form-control";
import AsyncSelect from "react-select/async";
import { MultiValue, OnChangeValue, OptionsOrGroups } from "react-select";
import { LabelValue } from "@app/types";

interface CustomAsyncMultiSelect extends FormControlChildProps {
  placeholder?: string;

  className?: string;

  value?: MultiValue<LabelValue>;

  defaultValue?: MultiValue<LabelValue>;

  defaultStatus?: undefined | "valid" | "inValid" | "warn";

  errorClassName?: string;

  promiseOptions: (
    inputValue: string
  ) => Promise<OptionsOrGroups<LabelValue, any>> | void;
}

function CustomAsyncMultiSelect({
  id,
  formik,
  placeholder,
  value = [],
  defaultValue = undefined,
  name,
  status,
  defaultStatus = undefined,
  errorClassName = "",
  className = "",
  promiseOptions,
  fmOnChange,
}: CustomAsyncMultiSelect) {
  const [txValue, setTxValue] = useState(value);
  const [_status, changeStatus] = useState(status || defaultStatus);

  const handleChange = useCallback(
    async (newValue: OnChangeValue<LabelValue, true>) => {
      setTxValue(newValue);

      if (formik) {
        formik.setFieldValue(name!, newValue);
      }

      setTimeout(() => {
        if (formik) {
          formik.setFieldTouched(name!, true);
        }
      });
    },
    [fmOnChange, formik, name]
  );

  useEffect(() => {
    if (value?.length) {
      setTxValue(value);
    }
  }, [value]);

  useEffect(() => {
    if (defaultValue) {
      setTxValue(defaultValue);
    }
  }, [defaultValue]);

  useEffect(() => {
    changeStatus(status || defaultStatus);
  }, [defaultStatus, status]);

  const isError = _status === "inValid" || _status === "warn";

  return (
    <div>
      <div className={`w-full ${className}`}>
        <AsyncSelect
          id={id}
          placeholder={placeholder}
          cacheOptions
          isMulti
          defaultOptions
          value={txValue}
          onChange={handleChange}
          loadOptions={promiseOptions}
          styles={{
            control: (baseStyles) => ({
              ...baseStyles,
              backgroundColor: "#f4f5fa",
              minHeight: "52px",
              borderColor: isError ? "#fc4040" : "",
            }),
          }}
        />
      </div>
      {isError && (
        <div className={`flex error-color text-xs ${errorClassName}`}>
          {formik &&
            formik.getFieldMeta(name!).error &&
            formik.getFieldMeta(name!).error}
        </div>
      )}
    </div>
  );
}

export default CustomAsyncMultiSelect;
